import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE } from '@cpak/shared/injectors';
import { UserFacade } from '@cpak/main-features-lib/data-store';
import { filter, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private userId!: string;

  constructor(@Inject(LOCAL_STORAGE) public localStorage: Storage, private userFacade: UserFacade) {
    this.userFacade
      .getUserId()
      .pipe(
        filter(userId => !!userId),
        take(1)
      )
      .subscribe(userId => {
        if (userId) {
          this.userId = userId;
        }
      });
  }

  public getItem<T>(key: string): T {
    const storedValue = this.localStorage.getItem(this.createKey(key));
    return storedValue ? JSON.parse(storedValue) : null;
  }

  public setItem(key: string, value: unknown): void {
    this.localStorage.setItem(this.createKey(key), JSON.stringify(value));
  }

  public remove(key: string): void {
    this.localStorage.removeItem(this.createKey(key));
  }

  public clear(): void {
    this.localStorage.clear();
  }

  public createKey(key: string): string {
    return `${this.userId ? this.userId + '-' : ''}${key}`;
  }

  public getItemWithoutKey<T>(key: string): T {
    const storedValue = this.localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  }

  public setItemWithoutKey(key: string, value: unknown): void {
    this.localStorage.setItem(key, JSON.stringify(value));
  }

  public removeWithoutKey(key: string): void {
    this.localStorage.removeItem(key);
  }
}
